const solarResources = [
  {
    id: 1,
    title: "Solar Design Basics",
    description: "An introductory guide to solar panel and inverter sizing.",
    longDescription: `This material is a perfect starting point for those new to solar design. It breaks down key concepts such as load calculation, peak sun hours, panel wattage, inverter sizing, and battery bank setup. Step-by-step examples and simplified formulas make it easy to follow and apply in real-life installations.`,
    price: 3000,
    downloadLink: "/pdfs/Solar-Design-Basics.pdf", // for display or direct link
    pdfName: "Solar-Design-Basics.pdf", // backend uses this to find the file
  },
  {
    id: 2,
    title: "Advanced Solar Installation",
    description: "Detailed procedures and best practices for solar installations.",
    longDescription: `This guide offers a professional deep dive into the solar installation process—from mounting structures and wiring diagrams to load balancing and system optimization. It covers grid-tied, off-grid, and hybrid installations, with safety standards and compliance tips to ensure reliable and code-compliant systems.`,
    price: 5000,
    downloadLink: "/pdfs/Advanced-Solar-Installation.pdf",
    pdfName: "Advanced-Solar-Installation.pdf",
  },
  {
    id: 3,
    title: "Solar Business Blueprint",
    description: "How to start and grow a profitable solar business in Nigeria.",
    longDescription: `This blueprint provides a practical roadmap for launching and scaling a solar business in Nigeria or similar emerging markets. It discusses pricing strategies, customer acquisition, licensing, sourcing affordable components, and navigating regulatory challenges. Perfect for aspiring entrepreneurs looking to break into the energy space.`,
    price: 4000,
    downloadLink: "/pdfs/Solar-Business-Blueprint.pdf",
    pdfName: "Solar-Business-Blueprint.pdf",
  },
  {
    id: 4,
    title: "Complete Solar Sizing",
    description: "Comprehensive guide to solar load calculation, battery and inverter sizing.",
    longDescription: `This all-in-one PDF provides everything you need to accurately size a solar system. It covers load analysis, system autonomy, battery storage capacity, inverter ratings, and PV module calculations. The guide includes worksheets and worked examples that simplify even the most technical parts of system design.`,
    price: 6000,
    downloadLink: "/pdfs/Complete-Solar-Sizing.pdf",
    pdfName: "Complete-Solar-Sizing.pdf",
  },
  {
    id: 5,
    title: "Solar Marketing Toolkit",
    description: "Templates and strategies for marketing your solar services.",
    longDescription: `This toolkit contains done-for-you marketing templates, social media strategies, lead conversion tactics, and branding advice tailored for solar installers and consultants. It helps you attract more clients, pitch your services with clarity, and build a reputable solar brand that stands out in a competitive market.`,
    price: 4000,
    downloadLink: "/pdfs/Solar-Marketing-Toolkit.pdf",
    pdfName: "Solar-Marketing-Toolkit.pdf",
  },

  /*
  {
    id: 6,
    title: "Hybrid Solar Systems Explained",
    description: "Understanding hybrid systems: components, wiring, and setup.",
    longDescription: `This resource demystifies hybrid solar systems—those that combine grid, solar, and battery power. You'll learn about the components, wiring diagrams, and operation logic of hybrid setups. It also explains how to manage energy flow, program inverters, and ensure seamless switching between power sources.`,
    price: 1800,
    downloadLink: "https://example.com/hybrid-systems.pdf",
  },
  {
    id: 7,
    title: "Battery Technologies for Solar",
    description: "Comparison of battery types used in solar power systems.",
    longDescription: `Explore the different battery technologies used in solar installations, including lithium-ion, AGM, gel, and tubular batteries. The guide compares lifecycle costs, charging behavior, maintenance requirements, and suitability for different applications. Ideal for designers and technicians who want to make informed battery choices.`,
    price: 1600,
    downloadLink: "https://example.com/solar-batteries.pdf",
  },
  {
    id: 8,
    title: "Inverter Troubleshooting Guide",
    description: "Common inverter errors and how to fix them.",
    longDescription: `This hands-on manual provides detailed instructions for diagnosing and fixing inverter-related issues. It includes error code explanations, real-world case scenarios, and maintenance checklists for common brands. A must-have for technicians looking to reduce downtime and improve system reliability.`,
    price: 1400,
    downloadLink: "https://example.com/inverter-guide.pdf",
  },
  {
    id: 9,
    title: "Solar Wiring & Safety",
    description: "Diagrams and best practices for safe solar wiring.",
    longDescription: `This technical guide focuses on the safe and efficient wiring of solar systems. It covers proper cable sizing, grounding techniques, circuit protection devices, and common wiring faults. Includes color-coded diagrams and safety protocols aligned with international and Nigerian electrical standards.`,
    price: 2000,
    downloadLink: "https://example.com/solar-wiring.pdf",
  },
  {
    id: 10,
    title: "How to Size Solar Streetlights",
    description: "Calculate the right specifications for streetlight installations.",
    longDescription: `Learn how to design solar-powered streetlight systems with precision. This guide teaches how to determine power requirements, battery capacity, and panel size for various lighting conditions. It’s particularly useful for contractors bidding on solar streetlight projects or managing government electrification jobs.`,
    price: 1700,
    downloadLink: "https://example.com/streetlight-sizing.pdf",
  },
  {
    id: 11,
    title: "Solar Maintenance Checklist",
    description: "Routine maintenance steps to extend solar system lifespan.",
    longDescription: `Ensure the long-term performance of solar systems with this step-by-step maintenance checklist. It covers weekly, monthly, and annual inspection routines for solar panels, batteries, inverters, and wiring. Also includes troubleshooting tips and log sheet templates for commercial or residential use.`,
    price: 1000,
    downloadLink: "https://example.com/maintenance-checklist.pdf",
  },
  {
    id: 12,
    title: "Off-Grid Solar Systems",
    description: "Planning and deploying solar systems for rural areas.",
    longDescription: `This guide explains the unique requirements for off-grid solar installations. It addresses rural electrification, system autonomy, weather variability, and affordable component sourcing. Great for NGOs, rural development contractors, or anyone tasked with delivering solar power where grid access is unavailable.`,
    price: 2200,
    downloadLink: "https://example.com/offgrid-systems.pdf",
  },
  {
    id: 13,
    title: "DC vs AC Loads in Solar",
    description: "Understanding load types and implications in system design.",
    longDescription: `Gain clarity on the differences between DC and AC loads in solar systems. This guide discusses energy efficiency, conversion losses, appliance compatibility, and wiring approaches. It helps you design better systems by understanding how load types influence system performance and component choices.`,
    price: 1300,
    downloadLink: "https://example.com/dc-vs-ac.pdf",
  },
*/
];

export default solarResources;
